import {
  ADD_PAYMENT_PROJECT_REQUEST,
  ADD_PAYMENT_PROJECT_SUCCESS,
  ADD_PAYMENT_PROJECT_FAILURE,
  FETCH_PAYMENT_PROJECTS_REQUEST,
  FETCH_PAYMENT_PROJECTS_SUCCESS,
  FETCH_PAYMENT_PROJECTS_FAILURE,
  UPDATE_PAYMENT_PROJECTS_REQUEST,
  UPDATE_PAYMENT_PROJECTS_SUCCESS,
  UPDATE_PAYMENT_PROJECTS_FAILURE,
  DELETE_PAYMENT_PROJECTS_REQUEST,
  DELETE_PAYMENT_PROJECTS_SUCCESS,
  DELETE_PAYMENT_PROJECTS_FAILURE,
  CLEAR_PAYMENT_PROJECTS_ERROR,
} from "../actions/paymentProjectActionTypes";

const initialState = {
  paymentProjects: [],
  isLoading: false,
  addPaymentProjectError: null,
  fetchPaymentProjectsError: null,
  updatePaymentProjectError: null,
};

const paymentProjectReducer = (state = initialState, action) => {
  //switch (action.type) {
  // Generic loading state for all request actions
  switch (action.type) {
    case ADD_PAYMENT_PROJECT_REQUEST:
      return {
        ...state,
        isLoading: true,
        addPaymentProjectError: null,
      };

    case ADD_PAYMENT_PROJECT_SUCCESS:
      return {
        ...state,
        paymentProjects: [...state.paymentProjects, action.payload],
        isLoading: false,
        addPaymentProjectError: null,
      };

    case ADD_PAYMENT_PROJECT_FAILURE:
      return {
        ...state,
        isLoading: false,
        addPaymentProjectError: action.payload,
      };

    case FETCH_PAYMENT_PROJECTS_REQUEST:
      return {
        ...state,
        isLoading: true,
        errors: {
          ...state.errors,
          [action.type.replace("_REQUEST", "").toLowerCase()]: null,
        },
      };

    // Handle fetch payment projects success
    case FETCH_PAYMENT_PROJECTS_SUCCESS:
      console.log("Updated paymentProjects:", action.payload);
      return {
        ...state,
        isLoading: false,
        paymentProjects: action.payload,
        errors: { ...state.errors, fetchPaymentProjects: null },
      };

    case FETCH_PAYMENT_PROJECTS_FAILURE:
      return {
        ...state,
        isLoading: false,
        errors: {
          ...state.errors,
          fetchPaymentProjects: action.payload || "An error occurred.",
        },
      };

    case UPDATE_PAYMENT_PROJECTS_REQUEST:
      return {
        ...state,
        isLoading: true,
        updatePaymentProjectError: null,
      };

    case UPDATE_PAYMENT_PROJECTS_SUCCESS:
      return {
        ...state,
        paymentProjects: state.paymentProjects.map((project) =>
          project.id === action.payload.id ? action.payload : project,
        ),
        isLoading: false,
        updatePaymentProjectError: null,
      };

    case UPDATE_PAYMENT_PROJECTS_FAILURE:
      return {
        ...state,
        isLoading: false,
        updatePaymentProjectError: action.payload,
      };

    // Clear all errors
    case CLEAR_PAYMENT_PROJECTS_ERROR:
      return {
        ...state,
        errors: {
          fetchPaymentProjects: null,
        },
      };

    // Default state
    default:
      return state;
  }
};

export default paymentProjectReducer;
